//
import BranchOfficeModel from '@/models/General/GBranchOffice'
import CashDeskModel from '@/models/POS/PosCashDesk'
import CustomerModel from '@/models/Sale/SlCustomer'
import CustomerCreditOptionModel from '@/models/POS/PosCustomerCreditOption'
import SaleTypeModel from '@/models/POS/PosSaleType'
import StateModel from '@/models/General/GState'
import UserModel from '@/models/General/GUser'
import ProductModel from '@/models/Warehouse/WhProduct'

//
export default ({ g_branch_office_address }) => [
    {
        name: 'sl_customer_id',
        props: {
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Cliente',
            model: CustomerModel,
            noObject: true,
            paramSearch: 'search',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'wh_product_id',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Producto',
            model: ProductModel,
            noObject: true,
            paramSearch: 'search',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'pos_cash_desk_id',
        props: {
            itemText: 'name_case',
            itemValue: 'id',
            label: 'Caja',
            model: CashDeskModel,
            noObject: true,
            paramSearch: 'name',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'g_branch_office_id',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Sucursal',
            model: BranchOfficeModel,
            noObject: true,
            paramFilter: {
                address: g_branch_office_address,
            },
            paramSearch: 'address',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'g_cashier_user_id',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Cajero',
            model: UserModel,
            noObject: true,
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'g_supervisor_user_id',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Supervisor',
            model: UserModel,
            noObject: true,
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'g_seller_user_id',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Vendedor',
            model: UserModel,
            noObject: true,
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'pos_sale_type_id',
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            model: SaleTypeModel,
            noObject: true,
            paramSearch: 'type',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'pos_customer_credit_option_id',
        props: {
            itemText: 'credit_option',
            itemValue: 'id',
            label: 'Crédito',
            model: CustomerCreditOptionModel,
            noObject: true,
            paramSearch: 'credit_option',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'g_state_id',
        props: {
            itemText: 'state',
            itemValue: 'id',
            label: 'Estado',
            model: StateModel,
            noObject: true,
            paramFilter: {
                g_state_type_id: 8,
            },
            paramSearch: 'state',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'created_at_min',
        props: {
            label: 'Desde',
        },
        type: 'date-field',
        value: '',
    },
    {
        name: 'created_at_max',
        props: {
            label: 'Hasta',
        },
        type: 'date-field',
        value: '',
    },
]
